// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"a04f2405","208":"5ea2babf","225":"3ce3cb66","317":"00a7de64","339":"4cdac4c9","401":"23aff847","514":"b56efe72","548":"48ad5663","806":"c15318d6"}[chunkId] + ".chunk.js";
};